export default "__VITE_ASSET__Fja$j69u__"